import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Rocket, Clock } from "lucide-react";
import { Button } from "../components/ui/button";

const StartupLoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/list-product');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-white dark:from-gray-900 dark:to-gray-800">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 dark:bg-[#121212]/95 backdrop-blur border-b border-gray-200 dark:border-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-3 flex justify-between items-center h-16">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100"
          >
            <ArrowLeft size={20} />
            <img src="/logo.svg" alt="AI Fit Engine Logo" className="w-8 h-8" />
            <span className="text-xl sm:text-2xl font-bold">AI Fit Engine</span>
          </button>
          <div className="flex items-center gap-3 sm:gap-6">
            <button
              onClick={() => navigate('/about')}
              className="px-3 sm:px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 text-xs sm:text-sm font-medium transition-colors"
            >
              About
            </button>
          </div>
        </div>
      </header>

      {/* Coming Soon Message */}
      <div className="pt-32 pb-16 max-w-2xl mx-auto px-4 sm:px-8">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 sm:p-12 text-center">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center">
              <Rocket className="w-10 h-10 text-orange-600 dark:text-orange-400" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            Coming Soon!
          </h1>
          
          {/* Message */}
          <div className="mb-8">
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-4">
              This feature is currently unavailable as we are still in the launching process.
            </p>
            <div className="flex items-center justify-center gap-2 text-orange-600 dark:text-orange-400">
              <Clock size={20} />
              <p className="font-medium">
                Stay tuned - we're working hard to bring this to you!
              </p>
            </div>
          </div>

          {/* Info Box */}
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6 mb-8">
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              <strong>Want to list your AI product?</strong>
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              You can still submit your company for listing. We'll review your submission and add it to our platform once we launch!
            </p>
          </div>

          {/* CTA Button */}
          <Button
            onClick={() => navigate('/list-product')}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg"
          >
            List Your Company Now
          </Button>

          {/* Auto-redirect notice */}
          <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">
            Redirecting you to the listing form in 5 seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default StartupLoginPage;